<template>
  <div class="container">
    <img :src="dataInfo.coverImage" class="brief-img" alt="">
    <div class="brief" v-html="dataInfo.content"></div>
  </div>

</template>

<script>

export default {
  name: "briefIntroduction",
  components: {},
  data() {
    return {
      dataInfo: {}
    };
  },
  props: {},
  computed: {},
  mounted() {
    this.getTenantService()
  },
  methods: {
    async getTenantService() {
      try {
        let { data } = await this.$api.getExtendedIntroduction();
        this.dataInfo = data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.brief {
  margin-top: 62px;
  margin-bottom: 62px;
  line-height: 1.5;
}
.brief-img{
  width: 100%;
  height: auto;
  margin-top: 60px;
  object-fit: fill;
  -o-object-fit: fill;
}
</style>
